import { QueryParams } from './types';

const truthyParams: [boolean, string] = [true, 'true'];

// these query params are specifically for params that need to be persisted throughout
// the flow, rather than page-specific params
export default (rawParams: { [key: string]: any }): QueryParams => ({
  skipChat: truthyParams.includes(rawParams.skipChat),
});
